/**
 * В каком мессенджере запущено приложение.
 *
 * MAX повторил схему Telegram целиком: тот же объект `WebApp`, тот же формат
 * initData, тот же стартовый параметр. Отличается токен бота, которым подписаны
 * данные, — а значит и ручка входа: чужим токеном подпись не сойдётся.
 *
 * Определяем по адресу страницы и по тому, чем себя называет клиент. На адрес
 * полагаться нельзя одному: приложение живёт на одном домене для обоих
 * мессенджеров, и различает их только клиент.
 */

export type Messenger = "telegram" | "max";

/** Как называет себя клиент MAX в поле платформы. */
const MAX_PLATFORMS = ["max", "maxweb", "max_android", "max_ios"];

export function detectMessenger(): Messenger {
  const webApp = (window as any).Telegram?.WebApp;
  const platform = String(webApp?.platform ?? "").toLowerCase();

  if (MAX_PLATFORMS.some((name) => platform.includes(name))) {
    return "max";
  }

  // Запасной признак: MAX открывает приложение со своего домена, и в адресе
  // страницы остаётся отсылающая сторона.
  const referrer = String(document.referrer || "").toLowerCase();
  if (referrer.includes("max.ru")) {
    return "max";
  }

  return "telegram";
}

/** Куда слать вход и проверку для текущего мессенджера. */
export function authEndpoints(messenger: Messenger = detectMessenger()) {
  if (messenger === "max") {
    return {
      signin: "/api/auth/max/signin",
      validate: "/api/auth/max/validate",
      // Подтверждение телефона в MAX сливает запись с телеграмной, если этот
      // телефон уже подтверждён там: это один человек, и запись должна быть одна.
      verify: "/api/auth/max/verify",
      register: "/api/auth/max/register",
      header: "Max-Token",
    };
  }

  return {
    signin: "/api/auth/telegram/apps/signin",
    validate: "/api/auth/telegram/validate",
    verify: "/api/auth/telegram/apps/verify",
    register: "/api/auth/telegram/apps/register",
    header: "Telegram-Token",
  };
}
